import React from 'react';
import PropTypes from 'prop-types';

import {Box, Chip, Paper, Stack, Typography} from 'views/components';
import {ArrowDownwardOutlined, ArrowUpwardOutlined} from 'views/icons';
import {Translate} from 'views/module';

const toneStyles = {
  positive: {
    color: '#21892C',
    backgroundColor: '#E3FAE5',
  },
  negative: {
    color: '#DA7955',
    backgroundColor: '#FFF1EC',
  },
  neutral: {
    color: '#919191',
    backgroundColor: '#F2F0EC',
  },
};

const MetricCard = (props) => {
  const {
    label,
    value,
    previousValue,
    chip = null,
    caption = null,
  } = props;

  const toneStyle = chip ? toneStyles[chip.tone] || toneStyles.neutral : null;

  return (
    <Paper
      sx={{
        p: 2.5,
        borderRadius: '8px',
        border: '1px solid #E5E5E5',
        boxShadow: 'none',
        display: 'flex',
      }}
    >
      <Stack spacing={1.5} sx={{flex: 1, minWidth: 0}}>
        <Box sx={{flex: 1, minWidth: 0}}>
          <Typography
            sx={{
              fontSize: '11px',
              fontWeight: 600,
              lineHeight: '14px',
              letterSpacing: '0.04em',
              color: '#A8A49E',
              mb: 1.5,
            }}
          >
            {label}
          </Typography>
          <Typography
            sx={{
              fontSize: '24px',
              fontWeight: 600,
              lineHeight: '31px',
              color: '#1A1916',
            }}
          >
            {value}
          </Typography>
          {
            caption &&
            <Typography
              sx={{
                fontSize: '11px',
                lineHeight: '14px',
                color: '#A8A49E',
                mt: 0.75,
              }}
            >
              {caption}
            </Typography>
          }
        </Box>
        <Box sx={{borderTop: '1px solid #EAEAEA'}} />
        <Stack direction='row' gap={1} alignItems='center'>
          {
            chip &&
            <Chip
              icon={
                chip.direction === 'down' ?
                  <ArrowDownwardOutlined sx={{fontSize: '14px !important', color: toneStyle.color}} /> :
                  <ArrowUpwardOutlined sx={{fontSize: '14px !important', color: toneStyle.color}} />
              }
              label={chip.label}
              sx={{
                'height': 22,
                'backgroundColor': toneStyle.backgroundColor,
                'borderRadius': '20px',
                'color': toneStyle.color,
                'fontSize': '11px',
                'fontWeight': 500,
                '& .MuiChip-label': {
                  px: 1,
                },
              }}
            />
          }
          <Typography
            sx={{
              fontSize: '11px',
              fontWeight: 500,
              lineHeight: '14px',
              color: '#A8A49E',
            }}
          >
            <Translate
              expression='metrics.ClientMetrics.Previous'
              substitute={{value: previousValue}}
            />
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};

MetricCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  chip: PropTypes.shape({
    direction: PropTypes.oneOf(['up', 'down', 'flat']).isRequired,
    tone: PropTypes.oneOf(['positive', 'negative', 'neutral']).isRequired,
    label: PropTypes.string.isRequired,
  }),
  caption: PropTypes.string,
};

export default React.memo(MetricCard);
